import { Box, Text } from "@chakra-ui/react";

import {
  ERROR_BANNER_HEIGHT_PX,
  outage,
  portfolioTrackingOutage,
} from "@/constants/shared";

export const ErrorBanner = () => {
  if (outage) {
    return (
      <Box
        p={3}
        textAlign="center"
        position="fixed"
        top={0}
        left={0}
        right={0}
        bgColor="#FFD7D0"
        zIndex="max"
        fontWeight="500"
        h={`${ERROR_BANNER_HEIGHT_PX}px`}
      >
        <Text color="#922100" fontSize="sm" fontWeight="700">
          We are currently experiencing delays with user activity tracking. Once
          our systems are recovered, your rewards will be retroactively awarded.
        </Text>
      </Box>
    );
  }
  if (portfolioTrackingOutage) {
    return (
      <Box
        p={3}
        textAlign="center"
        position="fixed"
        top={0}
        left={0}
        right={0}
        bgColor="#FFD7D0"
        zIndex="max"
        fontWeight="500"
        h={`${ERROR_BANNER_HEIGHT_PX}px`}
      >
        <Text color="#922100" fontSize="md" fontWeight="700">
          We are currently experiencing delays with user portfolio tracking.
          Only the Assets table on the portfolio page is currently affected.
        </Text>
      </Box>
    );
  }
  return null;
};
